import { defineMessages } from "react-intl";

export const AiChatTranslations = defineMessages({
  newChat: {
    id: "AiChat.New.Chat",
    defaultMessage: "Neue Unterhaltung",
  },
  messagePlaceholder: {
    id: "AiChat.New.Message",
    defaultMessage: "Geben Sie Ihre Frage ein.",
  },
  pdfLoadError: {
    id: "AiChat.PDF.Load.Error",
    defaultMessage: "Die PDF konnte nicht geladen werden, bitte benutzen Sie diesen alternativen Link.",
  },
  referenceMessage: {
    id: "AiChat.PreMenu.Message.Reference",
    defaultMessage: "Dokumentenverweis für dieses Gespräch: ",
  },
  referenceMessageLink: {
    id: "AiChat.PreMenu.Message.Reference.Link",
    defaultMessage: "hier klicken",
  },
  openButton: {
    id: "AiChat.PreMenu.Button.Open",
    defaultMessage: "Zur Support KI",
  },
});
